export var ButtonData_Type;
(function (ButtonData_Type) {
    /** LINK - Regular link button */
    ButtonData_Type["LINK"] = "LINK";
    /** ACTION - Triggers custom action that is defined in plugin configuration by the consumer */
    ButtonData_Type["ACTION"] = "ACTION";
    ButtonData_Type["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ButtonData_Type || (ButtonData_Type = {}));
//# sourceMappingURL=plugin_button.enums.js.map